$(function () {
    $(document).on("blur", "[required]", function () {
        if (!$(this).closest("#dropin-container").length) {
            if ($(this)[0].validity.valid) {
                $(this).removeClass("input-required");
                if ($(this).next().hasClass("error-required")) {
                    $(this).next().remove();
                }
            } else {
                $(this).addClass("input-required");

                console.log($(this));
                console.log($(this).data("custom-error"));

                if (!$(this).next().hasClass("error-required")) {
                    if ($(this).data("custom-error")) {
                        let errorMessage = $(this).data("custom-error");
                        $(
                            `<span class="block error-required">${errorMessage}</span>`
                        ).insertAfter($(this));
                    } else {
                        $(
                            '<span class="block error-required">Input required</span>'
                        ).insertAfter($(this));
                    }
                    
                }
            }
        }
    });
});
